import "./ProjectManagement.module.css";
import NavigationHeader from "@/reusable_sections/Header";
import ExpertiseEnMaitriseDoeuvre from "./sections/ExpertiseEnMaitriseDoeuvre";
import DeuxApprochesUneExcellence from "./sections/DeuxApprochesUneExcellence";
import PhasesDeRealisation from "./sections/PhasesDeRealisation";
import PropertyMaintenance from "./sections/PropertyMaintenance";
import PiedDePage from "@/reusable_sections/Footer";
export default function ProjectManagementPage() {
  return <div>
      <NavigationHeader />
      <ExpertiseEnMaitriseDoeuvre />
      <PropertyMaintenance />
      <DeuxApprochesUneExcellence />
      <PhasesDeRealisation />
      <PiedDePage />
    </div>;
}